module.exports = __webpack_public_path__ + "static/media/minaata.adec0a65.jpg";